'use client';

import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { getCresivoxBaseUrl } from '@/projectConfig/cresivoxBaseUrl';

interface Props {
  id: string;
  label?: string;
  value: string; // digits including country code, e.g. "919876543210"
  onChange: (digits: string) => void;
  disabled?: boolean;
}

/** Mobile field with a searchable country-code picker, pre-selected from the visitor's location (falls back to India). */
export function MobileCountryInput({ id, label = 'Mobile number', value, onChange, disabled }: Props) {
  const [country, setCountry] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const timer = setTimeout(() => !cancelled && setCountry((c) => c ?? 'in'), 1500);
    fetch(`${getCresivoxBaseUrl()}/geo/country`)
      .then((r) => (r.ok ? (r.json() as Promise<{ country?: string | null }>) : null))
      .then((d) => !cancelled && setCountry(d?.country || 'in'))
      .catch(() => !cancelled && setCountry('in'));
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <label htmlFor={id} style={{ fontSize: 14, fontWeight: 500 }}>{label}</label>
      {country ? (
        <PhoneInput
          country={country}
          value={value}
          onChange={onChange}
          disabled={disabled}
          enableSearch
          countryCodeEditable={false}
          inputProps={{ id, name: id, autoComplete: 'tel' }}
          inputStyle={{ width: '100%', height: 44 }}
          containerStyle={{ width: '100%' }}
        />
      ) : (
        <div style={{ height: 44, border: '1px solid var(--line)', borderRadius: 8 }} aria-busy="true" />
      )}
    </div>
  );
}
